<template>
  <v-app>
    <v-container>
      <v-row>
        <v-col cols="4">
          <v-btn
            @click="mode = 'list'"
            class="mr-2 mt-5"
            :class="{ amber: mode === 'list' }"
            :dark="mode !== 'list'"
            >List</v-btn
          >
          <v-btn
            @click="mode = 'cards'"
            class="mr-2 mt-5"
            :class="{ amber: mode === 'cards' }"
            :dark="mode !== 'cards'"
            >Cards</v-btn
          >
        </v-col>
        <v-col cols="6">
          <v-textarea
            label="Filter"
            color="amber"
            class=""
            v-model="term"
            :rows="1"
            :autoGrow="true"
            :hide-details="true"
          />
        </v-col>
      </v-row>
      <v-row v-if="rawProjects && mode === 'cards'">
        <v-col
          cols="6"
          class=""
          v-for="project in sortedList"
          :key="project.id"
        >
          <admin-card
            :path="`/users/project/${project.id}`"
            :title="project.title"
            type="Project"
            button="Go"
            :description="project.description"
          ></admin-card>
        </v-col>
      </v-row>
      <v-row v-if="rawProjects && mode === 'list'">
        <v-col cols="12">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Title</th>
                  <th class="text-left">Description</th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in sortedList" :key="item.id">
                  <td class="py-2">
                    <p>{{ item.title }}</p>
                  </td>
                  <td class="py-2">{{ item.description }}</td>
                  <td class="py-2">
                    <v-btn
                      small
                      light
                      class="amber mr-2"
                      :to="`/users/project/${item.id}`"
                    >
                      View
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { AdminCard } from "@/components/core";
const fb = require("@/firebaseConfig.js");
import lodash from "lodash";
export default {
  name: "UserDashboard",
  components: {
    AdminCard,
  },
  data() {
    return {
      projects: null,
      mode: "cards",
      term: "",
      rawProjects: null,
      processProjects: null,
      unsubscribe: null,
    };
  },
  mounted() {
    this.getProjects();
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
  },
  watch: {
    // auth can land after this view mounts, so fetch once we have a uid
    uid(val) {
      if (val) this.getProjects();
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    uid() {
      if (this.currentUser && this.currentUser.uid) return this.currentUser.uid;
      return fb.auth.currentUser ? fb.auth.currentUser.uid : null;
    },
    sortedList() {
      let arr = [];
      if (this.term !== "") {
        arr = this.rawProjects.filter((post) =>
          post.title.toLowerCase().includes(this.term.toLowerCase())
        );
      } else {
        arr = this.rawProjects;
      }
      return arr ? lodash.orderBy(arr, "title", "asc") : [];
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.getProjects();
    next();
  },
  methods: {
    getProjects() {
      // without a uid the query below throws, leaving the page blank
      if (!this.uid) return;

      if (this.unsubscribe) this.unsubscribe();

      let ref = fb.projectsCollection.where(
        "userListIds",
        "array-contains",
        this.uid
      );
      this.unsubscribe = ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((doc) => {
          let post = doc.data();
          items.push(post);
        });
        this.rawProjects = items;
      });
    },
  },
};
</script>
